import { analyticsRepository } from "@/repositories/analytics";
import { useStore } from "@/stores/useStore";
import { useCallback } from "react";

const TasksAnalyticsEventNames = {
  taskCreated: "task_created",
  tasksTabOpened: "tasks_tab_opened",
} as const;

type TasksAnalyticsEventNames =
  (typeof TasksAnalyticsEventNames)[keyof typeof TasksAnalyticsEventNames];

export interface LogTaskCreatedInput {
  dueDateMode: "exact" | "relative";
  hasAssignee: boolean;
  hasRelatedRO: boolean;
}

export type TasksTabOpenSource = "bell" | "toast" | "tab_click";

export const useTasksAnalytics = () => {
  const shopId = useStore((s) => s.shopId);

  const analyticsWrapper = useCallback(
    (eventName: TasksAnalyticsEventNames, params?: Record<string, unknown>) => {
      if (!shopId) {
        console.error(
          "Shop ID is missing, cannot log analytics event:",
          eventName
        );
        return;
      }
      analyticsRepository.logAnalyticsEvent(eventName, { ...params, shopId });
    },
    [shopId]
  );

  const logTaskCreated = (input: LogTaskCreatedInput) => {
    analyticsWrapper(TasksAnalyticsEventNames.taskCreated, { ...input });
  };

  const logTasksTabOpened = (source: TasksTabOpenSource) => {
    analyticsWrapper(TasksAnalyticsEventNames.tasksTabOpened, { source });
  };

  return { logTaskCreated, logTasksTabOpened };
};
